module.exports = (__parcel__import__("./" + "Debugger.worker.ab29d8a7.js")).then(() => parcelRequire('8GHQT'));